"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.useSidebar = void 0;

var _react = require("react");

var SidebarContext = /*#__PURE__*/(0, _react.createContext)();
SidebarContext.displayName = 'SidebarContext';

var useSidebar = function useSidebar() {
  var context = (0, _react.useContext)(SidebarContext);

  if (!context) {
    throw new Error('useSidebar must be used within a Sidebar');
  }

  return context;
};

exports.useSidebar = useSidebar;
var _default = SidebarContext;
exports["default"] = _default;

//# sourceMappingURL=SidebarContext.js.map